<template>
  <div class="head-box">
    <div class="logo">
      <img src="@/assets/img/logo.png" @click="onQDS" alt="">
    </div>
    <div class="head-content">
      <div class="head-title">
        <nav class="home-title" @click="onHome">个人中心</nav>
      </div>
      <div class="head-user">
        <div class="user-box">
          <el-avatar class="mr-3" :size="32" :src="userInfo.userImg ? this.$imgBaseUrl + userInfo.userImg : 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'" />
          <span class="user-name">{{userInfo.userName}}</span>
          <div class="service" v-if="false">
            <div :class="index == infoList.length - 1 ? '' : 'service-item'" style="padding: 10px 0;"
              v-for="(item, index) in infoList" :key="index">
              <p class="item-list"
                :style="{ 'background': 'url(' + val.icon + ') no-repeat 20px center', 'background-size': '18px auto' }"
                v-for="(val, key) in item.children" :key="key" @click="goDown(val)">{{ val.name }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Common } from '@/common';
export default {
  data() {
    return {
      infoList: [
        {
          name: "用户",
          children: [
            {
              name: "合伙人中心",
              url: "/partner-center?isIndex=center",
              icon: require("../../../assets/img/head/icon-hhrzx.png"),
              inside: 1
            },
            {
              name: "切换为合伙人",
              url: "/agent/all-service/index",
              icon: require("../../../assets/img/head/icon-pt.png"),
              inside: 1
            }
          ]
        },
        {
          name: "信息",
          children: [
            {
              name: "个人信息",
              url: "/partner/setting-info",
              icon: require("../../../assets/img/head/icon-grxx.png"),
              inside: 1
            },
            {
              name: "我的收益",
              url: "/earnings.html",
              icon: require("../../../assets/img/head/icon-wdsy.png"),
              inside: 1
            },
            {
              name: "我的资产",
              url: "/balance/list",
              icon: require("../../../assets/img/head/icon-wdqd.png"),
              inside: 1
            },
            {
              name: "我的团队",
              url: "/agent/team/list",
              icon: require("../../../assets/img/head/icon-wdtd.png"),
              inside: 1
            },
            {
              name: "账户安全",
              url: "/personal-setting/account-security",
              icon: require("../../../assets/img/head/icon-zhaq.png"),
              inside: 1
            },
            {
              name: "独立网站",
              url: "http://mzw.quandashi.com/",
              icon: require("../../../assets/img/head/icon-dlwz.png"),
              inside: 0
            }
          ]
        },
        {
          name: "退出",
          children: [
            {
              name: "退出登录",
              url: "/index/logout",
              icon: require("../../../assets/img/head/icon-tcdl.png"),
              inside: 1
            }
          ]
        }
      ],
      qdsUrl: '',
      userInfo: {}
    };
  },

  mounted() {
    this.qdsUrl = process.env.VUE_APP_QDS_URL;
    this.userInfo = JSON.parse(decodeURIComponent(Common.getCookie("QDS_LOGIN_INFO_OFFICE") ? Common.getCookie("QDS_LOGIN_INFO_OFFICE") : "{}"));
  },

  methods: {
    // 返回官网
    onQDS() {
      window.location.href = this.qdsUrl;
    },
    // 返回个人中心
    onHome() {
      window.location.href = this.qdsUrl + "/home/index";
    },
    // 去下一个页面
    goDown(data) {
      let self = this;
      if (data.inside == 1) {
        if (data.name == "退出登录") {
          self.logout(data);
        } else {
          window.location.href = self.qdsUrl + data.url;
        }
      } else {
        window.open(data.url, '_blank')
      }
    },
    // 退出登录
    async logout() {
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = this.qdsUrl + "/index/logout";
    },
  },
};
</script>
<style lang="less" scoped>
.head-box {
  width: 1240px;
  height: 60px;
  display: flex;

  .logo {
    width: 126px;
    display: flex;
    align-items: center;

    img {
      height: 32px;
      cursor: pointer;
    }
  }

  .head-content {
    flex: 1;
    display: flex;

    .head-title {
      flex: 1;
      padding-left: 60px;

      .home-title {
        width: 100px;
        text-align: center;
        font-size: 20px;
        font-weight: bold;
        color: #ff7200;
        cursor: pointer;
        line-height: 60px;
      }
    }

    .head-user {
      width: 90px;
      display: flex;
      align-items: center;

      .user-box {
        width: 90px;
        height: 32px;
        display: flex;
        align-items: center;
        // background: url('@/assets/img/head/icon-more-arrow.png') no-repeat 100% 100%;
        // background-size: 6px;
        position: relative;

        .user-name {
          display: inline-block;
          padding-left: 9px;
        }

        .service {
          display: none;
          position: absolute;
          right: 5px;
          top: 32px;
          left: auto;
          width: 200px;
          height: auto;
          box-shadow: 0px 0px 6px 0px rgb(11 17 60 / 10%);
          border-radius: 2px;
          background: white;
          z-index: 999;

          .service-item {
            border-bottom: 4px solid #f7f7f8;
          }

          .item-list {
            padding-left: 54px;
            height: 36px;
            line-height: 36px;
            font-size: 13px;
            color: #666;
            cursor: pointer;
          }
        }
      }

      .user-box:hover>.service {
        display: block;
      }
    }
  }
}
</style>